import React, { useState } from 'react';
import { apiService } from '../services/api';

const SearchResultsPage = ({ searchData, onSearch, onAnalyzeVideo, onAnalyzeChannel }) => {
  const [query, setQuery] = useState(searchData?.query || '');
  const [results, setResults] = useState(searchData?.results || null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSearch = async (e) => {
    e.preventDefault();
    if (!query.trim()) return;
    try {
      setLoading(true);
      setError(null);
      const response = await apiService.searchYouTube(query.trim(), 30);
      const newResults = response.results;
      setResults(newResults);
      if (onSearch) {
        onSearch({ query: query.trim(), results: newResults });
      }
    } catch (err) {
      setError(err.message || 'Failed to load search results');
    } finally {
      setLoading(false);
    }
  };

  const handleAnalyzeClick = (type, item) => {
    if (type === 'video' && onAnalyzeVideo) {
      onAnalyzeVideo(`https://www.youtube.com/watch?v=${item.id}`);
    } else if (type === 'channel' && onAnalyzeChannel) {
      const url = item.custom_url ? `https://www.youtube.com/${item.custom_url}` : `https://www.youtube.com/channel/${item.id}`;
      onAnalyzeChannel(url);
    } else if (type === 'playlist' && onAnalyzeVideo) {
      onAnalyzeVideo(`https://www.youtube.com/playlist?list=${item.id}`);
    }
  };

  const renderResultsSection = (title, list, type) => {
    if (!list || list.length === 0) return null;
    return (
      <div style={{ marginTop: '2rem' }}>
        <h3 style={{ color: '#8b5cf6', marginBottom: '1rem' }}>{title}</h3>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '1.5rem' }}>
          {list.map((item) => (
            <div key={item.id} style={{ background: 'rgba(15, 15, 35, 0.92)', border: '1px solid rgba(139, 92, 246, 0.3)', borderRadius: '16px', padding: '1rem' }}>
              {item.thumbnail && (
                <img src={item.thumbnail} alt={item.title} style={{ width: '100%', borderRadius: '12px', marginBottom: '0.75rem', objectFit: 'cover' }} />
              )}
              <h4 style={{ color: '#e5e7eb', fontSize: '1rem', marginBottom: '0.5rem' }}>{item.title}</h4>
              {item.channel_title && <p style={{ color: '#9ca3af', marginBottom: '0.5rem', fontSize: '0.9rem' }}>{item.channel_title}</p>}
              <div style={{ display: 'flex', gap: '0.75rem' }}>
                <button
                  onClick={() => handleAnalyzeClick(type, item)}
                  style={{
                    border: 'none',
                    borderRadius: '999px',
                    padding: '0.45rem 1.2rem',
                    background: 'linear-gradient(135deg, #8b5cf6, #ec4899)',
                    color: '#fff',
                    fontWeight: '600',
                    cursor: 'pointer'
                  }}
                >
                  Analyze
                </button>
                <a
                  href={
                    type === 'video'
                      ? `https://www.youtube.com/watch?v=${item.id}`
                      : type === 'channel'
                      ? (item.custom_url ? `https://www.youtube.com/${item.custom_url}` : `https://www.youtube.com/channel/${item.id}`)
                      : `https://www.youtube.com/playlist?list=${item.id}`
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: '#8b5cf6', textDecoration: 'none', fontWeight: '600', alignSelf: 'center' }}
                >
                  View on YouTube
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  return (
    <div style={{ minHeight: '100vh', padding: '120px 5% 60px', background: 'linear-gradient(135deg, #0f0f23 0%, #1a1a3a 100%)' }}>
      <div style={{ maxWidth: '650px', margin: '0 auto', textAlign: 'center' }}>
        <h1 style={{ color: '#f1f5f9', fontSize: '2.9rem', marginBottom: '1.75rem', fontWeight: 700 }}>
          Search YouTube
        </h1>

        <form onSubmit={handleSearch} style={{ display: 'flex', gap: '1rem', marginBottom: '2rem', justifyContent: 'center' }}>
          <input
            type="text"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Search for videos, channels, playlists..."
            style={{
              flex: 1,
              padding: '0.9rem 1.2rem',
              borderRadius: '999px',
              border: '1px solid rgba(139, 92, 246, 0.3)',
              background: 'rgba(15,15,35,0.85)',
              color: '#e5e7eb',
              fontSize: '1rem'
            }}
          />
          <button
            type="submit"
            disabled={loading}
            style={{
              padding: '0.9rem 1.8rem',
              borderRadius: '999px',
              border: 'none',
              background: 'linear-gradient(135deg, #8b5cf6, #ec4899)',
              color: '#fff',
              fontWeight: '600',
              cursor: loading ? 'not-allowed' : 'pointer'
            }}
          >
            {loading ? 'Searching...' : 'Search'}
          </button>
        </form>

        {error && <p style={{ color: '#f87171', marginBottom: '1rem' }}>{error}</p>}

        {results ? (
          <>
            {renderResultsSection('Videos', results.videos, 'video')}
            {renderResultsSection('Channels', results.channels, 'channel')}
            {renderResultsSection('Playlists', results.playlists, 'playlist')}

            {!results.videos?.length && !results.channels?.length && !results.playlists?.length && (
              <div style={{ color: '#9ca3af', textAlign: 'center', padding: '2rem', background: 'rgba(15,15,35,0.8)', borderRadius: '16px' }}>
                No results found. Try another search.
              </div>
            )}
          </>
        ) : (
          <div style={{ color: '#9ca3af', textAlign: 'center', padding: '2rem', background: 'rgba(15,15,35,0.8)', borderRadius: '16px' }}>
            Enter a search query to see results from YouTube.
          </div>
        )}
      </div>
    </div>
  );
};

export default SearchResultsPage;

